import React from "react";
import { cn } from "../../../common/u1/cn";

/* The Billing page's title block.
 *
 * Both lines are props so a variant of this screen can retitle it without a
 * second component — the same shape MembershipHeader uses.
 */
export const BillingHeader = ({
  title = "Billing",
  intro = "Update your payment details, switch plans, and download any invoice you have paid.",
  className = "",
}) => (
  <div className={cn("min-w-0", className)}>
    <h2 className="m-0 text-[26px] font-bold tracking-[-.01em] text-[var(--ink)] font-sans">
      {title}
    </h2>
    {intro && (
      <p className="mt-1.5 mb-0 max-w-[520px] text-[14.5px] leading-[1.5] text-[var(--ink-2)] font-sans">
        {intro}
      </p>
    )}
  </div>
);

export default BillingHeader;
